import { render, staticRenderFns } from "./PriceCardDetails.vue?vue&type=template&id=f0a92222&"
import script from "./PriceCardDetails.vue?vue&type=script&lang=js&"
export * from "./PriceCardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports